import { styled } from '../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const LogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    flex-shrink: 0;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 200px;
    object-fit: contain;
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    overflow-y: auto;
    padding: 28px 20px 24px;
    gap: 20px;
`;

export const WarningBlock = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 22px;
    font-weight: 700;
    color: ${({ $color }) => $color};
    margin: 0;
    line-height: 1.2;
    letter-spacing: -0.2px;
    text-align: center;
`;

export const IntroText = styled.p`
    font-size: 14.5px;
    font-weight: 700;
    color: #2d3748;
    margin: 0;
    line-height: 1.5;
`;

export const BulletList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const BulletItem = styled.li`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
`;

export const BulletMark = styled.span`
    flex-shrink: 0;
    color: #c53030;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.5;
`;

export const BulletText = styled.span`
    font-size: 14px;
    color: #4a5568;
    line-height: 1.5;
`;

export const HighlightText = styled.p`
    font-size: 14.5px;
    font-weight: 700;
    color: #2d3748;
    margin: 4px 0 0;
    line-height: 1.5;
`;

export const InfoText = styled.p`
    font-size: 14px;
    color: #4a5568;
    margin: 0;
    line-height: 1.5;
`;

export const ContactList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 4px;
`;

export const ContactRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    background-color: #f7fafc;
`;

export const ContactIcon = styled.span`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4a5568;
`;

export const ContactTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const ContactLabel = styled.span`
    font-size: 13px;
    font-weight: 700;
    color: #2d3748;
`;

export const ContactValue = styled.span`
    font-size: 13px;
    color: #4a5568;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Footer = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 20px;
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    flex-shrink: 0;
`;

export const DismissButton = styled.button<{ $color: string }>`
    width: 100%;
    box-sizing: border-box;
    border: none;
    border-radius: 10px;
    padding: 16px 20px;
    font-family: inherit;
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    background-color: ${({ $color }) => $color};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 0.9;
    }
`;
